export default function(o){

  var update = function(currentTime){
    var smpte = o.util.secondsToSmpte(currentTime)
    var smpteShort = smpte.slice(3)
    div.html(smpteShort)
  }

  var div =
    $('<div>')
    .css({
      display: 'inline-block',
      margin: '0.3rem',
    })
    .html('00:00:00')

  div.update = update

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/timecode/timecode.js